import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { CheckoutStepService } from '@spartacus/checkout/base/components';
import { I18nModule } from '@spartacus/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GenShippingAccountType } from 'src/app/generac/enums/shipping-account-type.enum';
import { GenActiveCartService } from 'src/app/generac/features/cart/core/facade/active-cart.service';
import { GenShippingAccount, GenShippingCondition } from 'src/app/generac/models/cart.model';

@Component({
  selector: 'gen-checkout-delivery-method-selector',
  templateUrl: './checkout-delivery-method-selector.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    I18nModule,
    NgSelectModule,
    FormsModule,
  ]
})
export class GenCheckoutDeliveryMethodSelectorComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject();

  @Input() updateDeliveryMethods: Observable<GenShippingAccountType>;
  @Input() generacShippingAccounts: GenShippingAccount[];
  @Input() dealerShippingAccounts: GenShippingAccount[];
  @Input() selectedCarrier: string;
  @Input() selectedShippingCondition: string;
  @Output() carrierOptionSelected: EventEmitter<GenShippingAccount> = new EventEmitter();

  shippingAccount: GenShippingAccountType;
  carriers: GenShippingAccount[];
  shippingConditions: GenShippingCondition[];

  constructor(
    protected checkoutStepService: CheckoutStepService,
    protected activatedRoute: ActivatedRoute,
    protected activeCartFacade: GenActiveCartService,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    this.updateDeliveryMethods
      .pipe(takeUntil(this.destroy$))
      .subscribe((shippingAccount: GenShippingAccountType) => {
        let shippingAccountChanged = false;
        if (this.shippingAccount && this.shippingAccount != shippingAccount) shippingAccountChanged = true;
        this.shippingAccount = shippingAccount;
        this.carriers = this.isGeneracShippingAccount(shippingAccount) ? this.generacShippingAccounts : this.dealerShippingAccounts;
        if (!this.carriers || this.carriers?.length < 1) {
          this.selectedCarrier = null;
          this.shippingConditions = null;
          this.selectedShippingCondition = null;
          this.cdr.markForCheck();
          return;
        };

        if (!this.selectedCarrier || shippingAccountChanged) this.selectedCarrier = this.carriers[0].vendorId;

        if (this.selectedCarrier) {
          this.shippingConditions = this.carriers.find((c: GenShippingAccount) => c.vendorId == this.selectedCarrier)?.shippingConditions;
          if (!this.selectedShippingCondition || shippingAccountChanged) {
            this.selectedShippingCondition = this.shippingConditions[0].shippingConditionID;
          }
        }
        this.emitCarrierOptionSelected();
        this.cdr.markForCheck();
      });
  }

  carrierSelected(carrier: GenShippingAccount): void {
    this.shippingConditions = carrier.shippingConditions;
    this.selectedShippingCondition = this.shippingConditions[0].shippingConditionID;
    this.emitCarrierOptionSelected();
  }

  isGeneracShippingAccount(shippingAccount: GenShippingAccountType): boolean {
    return shippingAccount == GenShippingAccountType.GENERAC;
  }

  shippingConditionSelected(shippingCondition: string): void {
    this.emitCarrierOptionSelected();
  }

  emitCarrierOptionSelected(): void {
    const carrier = this.carriers.find((c: GenShippingAccount) => c.vendorId == this.selectedCarrier);
    const data: GenShippingAccount = {
      ...carrier,
      shippingConditions: carrier.shippingConditions?.filter((s: GenShippingCondition) => s.shippingConditionID == this.selectedShippingCondition)
    }
    this.carrierOptionSelected.emit(data);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);;
    this.destroy$.complete();
  }
}
